import type React from "react";
import type { ValidationError } from "class-validator";
import { SITE_TEXTS_BOOT_LOCALE } from "@Front/Stores/siteTextsBootConfig";
import { useSiteTextContent } from "@Front/Stores/SiteTextsContext";
import { buildStepEmailSiteTextsDisplay } from "./stepEmailSiteTextsDisplay";

/**
 * Site texts for StepEmail UI (only keys consumed by this step).
 */
export function useStepEmailSiteTexts(): ReturnType<typeof buildStepEmailSiteTextsDisplay> {
	const locale = SITE_TEXTS_BOOT_LOCALE;
	const welcomeTitle = useSiteTextContent("login.header.title");
	const welcomeSubtitle = useSiteTextContent("login.header.subtitle");
	const notarySectionTitle = useSiteTextContent("login.section.notaries.title");
	const notaryCta = useSiteTextContent("login.section.notaries.cta");
	const notarySubscribeCta = useSiteTextContent("login.section.notaries.subscribeCta");
	const clientsSectionTitle = useSiteTextContent("login.section.clients.title");
	const emailPlaceholder = useSiteTextContent("login.form.email.placeholder");
	const submitCta = useSiteTextContent("login.form.submit");
	return buildStepEmailSiteTextsDisplay({
		locale,
		welcomeTitle,
		welcomeSubtitle,
		notarySectionTitle,
		notaryCta,
		notarySubscribeCta,
		clientsSectionTitle,
		emailPlaceholder,
		submitCta,
	});
}

export type StepEmailSiteTexts = ReturnType<typeof useStepEmailSiteTexts>;

export type StepEmailOuterProps = {
	onSubmit: (e: React.FormEvent<HTMLFormElement> | null, values: { [key: string]: string }) => void;
	validationErrors: ValidationError[];
};
